import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';
// import Profile from "./containers/Profile";


const ChildrenSettingComponent = lazy(() => import('../../pages/Setting/containers/ChildrenSettingPageContainer'));
const Profile = lazy(() => import('../../pages/Setting/containers/Profile'));

const ChangePassword =  lazy(() => import('../../pages/Setting/containers/ChangePassword'));

const NotificationSetting = lazy(() => import('../../pages/Setting/containers/NotificationSetting'));

const route = [
  {
    path: ROUTERS.CHILDREN_SETTING,
    title: 'Login',
    exact: true,
    public: false,
    component: <ChildrenSettingComponent />,

  },
  {
    path: ROUTERS.PROFILE,
    title: 'Profile',
    exact: true,
    public: false,
    component: <Profile />,

  },
  {
    path: ROUTERS.CHANGE_PASSWORD,
    title: 'Change Password',
    exact: true,
    public: false,
    component: <ChangePassword />,

  },
  {
    path: ROUTERS.NOTIFICATION_SETTING,
    title: 'Notification Setting',
    exact: true,
    public: false,
    component: <NotificationSetting />,

  }
];

export default route;